module.exports = __webpack_public_path__ + "assets/f561c2f11c447c467fbd775fa67e4780.mp3";